import {Api} from 'utils/api';

const senseStagingDomains: {[key: string]: string} = {
  'stage-1': 'stage-chatbot',
  'stage-02': 'stage-chatbot-02',
  'stage-03': 'stage-chatbot-03',
  'stage-04': 'stage-chatbot-04',
  'stage-05': 'stage-chatbot-05',
  'stage-06': 'stage-chatbot-06',
};

function apiOriginFromLocation(origin: string): string {
  const hostname = new URL(origin).hostname;
  const domains = hostname.split('.');
  const stage = domains[1];

  // staging environment
  if (origin.includes('stage')) {
    return `https://chatbot-faqs.${senseStagingDomains[stage]}.sensehq.co`;
  }
  // preprod
  else if (origin.includes('sandbox-preprod')) {
    return `https://chatbot-faqs.sandbox-preprod.sensehq.com`;
  }
  // For production/development env, we use extension logic
  else {
    const extension = domains[domains.length - 1] === 'eu' ? 'eu' : 'co';
    return `https://chatbot-faqs.sensehq.${extension}`;
  }
}

export const faqApi = new Api(
  `${apiOriginFromLocation(window.location.origin)}/api/faqs`,
);

export const faqApiV2 = new Api(
  `${apiOriginFromLocation(window.location.origin)}/api/v2/faqs`,
);
